import React from 'react';
import { connect } from 'react-redux';
import CountUp from 'react-countup';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

function Summary({ overview }) {
  const items = [
    {
      title: '生产者',
      icon: 'producer',
      info: <CountUp end={overview.producerOnlineCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: '消费者',
      icon: 'consumer',
      info: <CountUp end={overview.consumerOnlineCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: '订阅',
      icon: 'subscription',
      info: (
        <>
          <CountUp end={overview.subscriptionOnlineCount} duration={0.4} />/
          <CountUp end={overview.subscriptionCount} duration={0.4} />
        </>
      ),
      unit: '个',
      tip: (
        <div>
          <strong>
            订阅({overview.subscriptionOnlineCount || 0}/{overview.subscriptionCount || 0})
          </strong>
          <li>{overview.subscriptionOnlineCount || 0}代表在线订阅数。</li>
          <li>{overview.subscriptionCount || 0}代表总订阅数。</li>
        </div>
      ),
    },
  ];
  return <SummaryPanel shadow={false} img={null} items={items} />;
}

export default connect((state) => ({
  overview: state.topic.detailOverview,
}))(Summary);
